import React from 'react';

import { useHistory } from 'react-router-dom';

import { Avatar, Box, Button, Card, CardActions, CardHeader, Container, Divider, Fade, Grid, Typography } from '@material-ui/core';

import { AccountBalance, Check, Done, EventAvailable, EventNote, HelpOutline, HowToReg, ListAlt, TouchApp } from '@material-ui/icons';

import { useStyles } from './slyles';

function Home(props) {

    const history = useHistory();

    const classes = useStyles();

    const agendar = () => {
        props.history.push('/agendamento');
    }

    return (

        <Fade in={true} timeout={700}>
            <div>
                <Container component="main" maxWidth="sm">
                    <Box display="flex" flexDirection="column" alignItems="center">
                        {/* <Avatar src="logo512.png" className={classes.large} /> */}
                        <img src="logo512.png" width="100" alt="logoPrincipal" />
                    </Box>

                    <Typography component="h1" variant="h4" align="center" color="textPrimary" gutterBottom>
                        Agendamento Online
                    </Typography>
                    <Typography variant="h6" align="center" color="textSecondary" paragraph>
                        Agende seu atendimento em uma de nossas secretarias
                    </Typography>
                    <div className={classes.heroButtons}>
                        <Box display="flex" flexDirection="column">
                            <Box>
                                <Grid container spacing={2} justify="center">
                                    <Grid item lg={6} md={6} sm={6} xl={6} xs={12}>
                                        <Card >
                                            <CardHeader className={classes.cardHeade} avatar={<Avatar className={classes.avatarRigth}><EventAvailable /></Avatar>} title="Agendar atendimento" subheader="Clique abaixo para agendar o seu atendimento" />

                                            <CardActions>
                                                <Button color="primary" size="small" variant="outlined" fullWidth={true} startIcon={<Done />} onClick={agendar}>Agendar</Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                    <Grid item lg={6} md={6} sm={6} xl={6} xs={12}>
                                        <Card >
                                            <CardHeader className={classes.cardHeade} avatar={<Avatar className={classes.avatarLetf}><EventNote /></Avatar>} title="Meus agendamentos" subheader="Clique abaixo para localizar o seu agendamento" />

                                            <CardActions>
                                                <Button color="secondary" size="small" variant="outlined" fullWidth={true} startIcon={<Done />} onClick={() => history.push('/meusagendamentos')}>Meus Agendamentos</Button>
                                            </CardActions>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </div>
                </Container>
                <Divider style={{ marginTop: 20, marginBottom: 20 }} />
                <Container>
                    <Box className={classes.heroButtons}>
                        <Grid container>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box display="flex" flexDirection="column" alignItems="center">
                                    <Box>
                                        <HelpOutline style={{ fontSize: 40 }} color="primary" />
                                    </Box>
                                    <Box>
                                        <Typography color="primary" variant="subtitle1" component="div"><Box fontWeight={600}>Como funciona?</Box></Typography>
                                    </Box>
                                    <Box>
                                        {/* <Typography color="primary" variant="subtitle2" align="center" component="div"><Box fontWeight={400}>Veja o passo a passo para agendar o seu atendimento em um de nossos serviços na Prefeitura de Porto Velho.</Box></Typography> */}
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={2} md={3} sm={4} xs={12}>
                                <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" p={2}>
                                    <Box>
                                        <Avatar style={{ backgroundColor: '#1976d2' }} className={classes.avatarHelp}><TouchApp /></Avatar>
                                    </Box>
                                    <Box m={2}>
                                        <Typography component="div" align="center" variant="caption"><Box>1º passo: Clique em AGENDAR.</Box></Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={2} md={3} sm={4} xs={12}>
                                <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" p={2}>
                                    <Box>
                                        <Avatar style={{ backgroundColor: '#7b1fa2' }} className={classes.avatarHelp}><ListAlt /></Avatar>
                                    </Box>
                                    <Box m={2}>
                                        <Typography component="div" align="center" variant="caption"><Box>2º passo: Leia com atenção as orientações gerais e clique em Li e concordo.</Box></Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={2} md={3} sm={4} xs={12}>
                                <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" p={2}>
                                    <Box>
                                        <Avatar style={{ backgroundColor: '#c62828' }} className={classes.avatarHelp}><HowToReg /></Avatar>
                                    </Box>
                                    <Box m={2}>
                                        <Typography component="div" align="center" variant="caption"><Box>3º passo: Selecione o tipo de atendimento. Se é atendimento ao Público em Geral ou ao Servidor Público Municipal.</Box></Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={2} md={3} sm={4} xs={12}>
                                <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" p={2}>
                                    <Box>
                                        <Avatar style={{ backgroundColor: '#e65100' }} className={classes.avatarHelp}><AccountBalance /></Avatar>
                                    </Box>
                                    <Box m={2}>
                                        <Typography component="div" align="center" variant="caption"><Box>4º passo: Localize o tipo de atendimento.</Box></Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={2} md={3} sm={4} xs={12}>
                                <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" p={2}>
                                    <Box>
                                        <Avatar style={{ backgroundColor: '#01579b' }} className={classes.avatarHelp}><EventAvailable /></Avatar>
                                    </Box>
                                    <Box m={2}>
                                        <Typography component="div" align="center" variant="caption"><Box>5º passo: Selecione a data e hora disponível.</Box></Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item lg={2} md={3} sm={4} xs={12}>
                                <Box display="flex" justifyContent="center" flexDirection="column" alignItems="center" p={2}>
                                    <Box>
                                        <Avatar style={{ backgroundColor: '#1b5e20' }} className={classes.avatarHelp}><Check /></Avatar>
                                    </Box>
                                    <Box m={2}>
                                        <Typography component="div" align="center" variant="caption"><Box>6º passo: Tudo pronto! Agendamento realizado com sucesso.</Box></Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Container>
            </div>
        </Fade>

    );
}

export default Home;
